<div class="cockpit-content">
  <h1 translate>m1.sprint5.cockpit.card.grafischerModellcheck.title</h1>
  <div>
    <app-chart-dialog-residuals-vs-fitted></app-chart-dialog-residuals-vs-fitted>
    <app-chart-dialog-qq-plot></app-chart-dialog-qq-plot>
  </div>
</div>
